import useLicenseCheck from "license/useLicenseCheck";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const useSecurityEventExecuteNotificationsCondition = () => {
  const { security } = useLicenseCheck();
  const currentUser = useCurrentUser();
  return (security == null ? void 0 : security.isValid) && isPermitted(currentUser.permissions, "security_event:execute_notifications");
};
export default useSecurityEventExecuteNotificationsCondition;
